export default __webpack_public_path__ + "ddk-logo.68531561.svg";